import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LinkExpiredPage = ({ title, link }) => {
  const navigate = useNavigate();

  const handleForgotPassword = () => {
    navigate("/" + link); // Redirect to forgot password page
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      textAlign="center"
      bgcolor="#f8f9fa">
      <Typography variant="h4" fontWeight="bold" color="#c62828" gutterBottom>
        ❌ Link Expired
      </Typography>
      <Typography variant="h6" color="textSecondary" mb={2}>
        The link you tried to access has expired. Please request a new one.
      </Typography>

      {/* ✅ "Forgot Password?" - Styled as a blue clickable text */}
      <Button
        onClick={handleForgotPassword}
        sx={{
          color: "#007bff",
          fontWeight: "bold",
          fontSize: "1rem",
          cursor: "pointer",
          textTransform: "none", // Prevents capitalization
          "&:hover": {
            color: "#0056b3", // Slightly darker blue on hover
            backgroundColor: "transparent", // No background effect
          },
        }}>
        {title}
      </Button>
    </Box>
  );
};

export default LinkExpiredPage;
